var React = require('react');

function Check (props) {
    return React.createElement("svg",props,[React.createElement("path",{"fillRule":"evenodd","clipRule":"evenodd","d":"M12 22C17.5228 22 22 17.5228 22 12C22 6.47715 17.5228 2 12 2C6.47715 2 2 6.47715 2 12C2 17.5228 6.47715 22 12 22Z","fill":"#00A493","key":0}),React.createElement("path",{"d":"M7 11.8796L10.5052 15.3848L17.3847 8.50529","stroke":"white","strokeWidth":"2","key":1})]);
}

Check.defaultProps = {"width":"24","height":"24","viewBox":"0 0 24 24","fill":"none"};

module.exports = Check;

Check.default = Check;
